import {makeButtonList} from "./config";


export default {
  props:{
    query: { type:Object, default: () => null },
  },
  watch:{
    '$props.query':{
      deep: true,
      immediate:true,
      handler(value){
        if(!!value) this.getData()
      }
    }
  },
  data: () => ({
    buttonList:makeButtonList([3,2,1]),
    chartDataApi: null,
    filter: 3,
  }),
  computed:{
    isEmpty: (_this = this) => !_this.chartDataApi || !_this.chartDataApi?.length
  },
  methods: {
    getData(){
      const shopId = this.$route.params?.id
      const params = {
        ...this.$props.query,
        type: this.filter
      }
      this.$api.get(`/v2/shop/${shopId}/commodityCategoryDistribution`,{params}).
      then( res => this.chartDataApi = res?.data ).
      finally(() => {})
    }
  }
}

